<template>
    <slot name="form-request" v-bind="this"></slot>
</template>


<script>
    import FormValidator from "lib/form-validator.mjs";
    export default {
        props: {
            createUrl: { type: String, required: true },
            csrfToken: { type: String, required: true },
            messageValidate: { type: String, required: true },
        },
        data() {
            return {
                formValidator: new FormValidator({
                    firstName: {
                        required: true,
                        type: 'string',
                        min: 3,
                        max: 30
                    },
                    lastName: {
                        required: true,
                        type: 'string',
                        min: 3,
                        max: 30
                    },
                    email: {
                        required: true,
                        type: 'email'
                    },
                    address: {
                        required: true,
                        type: 'string',
                        min: 5,
                        max:50
                    },
                    city: {
                        required: true,
                        type: 'string',
                        min: 3,
                        max: 30
                    },
                    province: {
                        required: true,
                        type: 'string',
                        min: 3,
                        max: 30
                    },
                    zipCode: {
                        required: true,
                        type: 'string',
                        min: 3,
                        max: 10
                    },
                    telephone: {
                        required: true,
                        type: 'string',
                        min: 10,
                        max: 13,
                    }
                }, {
                    firstName: '',
                    lastName: '',
                    email: '',
                    address: '',
                    city: '',
                    province: '',
                    zipCode: '',
                    telephone: '',

                }),

                firstName: '',
                lastName: '',
                email: '',
                address: '',
                city: '',
                province: '',
                zipCode: '',
                telephone: '',
                country: '',


                errors: {
                    firstName: { init: 1 },
                    lastName: { init: 1 },
                    email: { init: 1 },
                    address: { init: 1 },
                    city: { init: 1 },
                    province: { init: 1 },
                    zipCode: { init: 1 },
                    telephone: { init: 1 },
                },
                generalError: false,
                submitLock: true,
                showSuccess: false,
                terms: false,
                privacy: false,
                errorMessageTerms: '',
                errorMessagePrivacy: '',
                showAlert:  false,
                redirectUrl: ''

            }
        },
        watch: {
            firstName(val) {
                this.hideError('firstName');
                this.formValidator.setValue('firstName', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('firstName', error);
                        this.evaluateButtonStatus();
                    }
                );
            },
            lastName(val) {
                this.hideError('lastName');
                this.formValidator.setValue('lastName', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('lastName', error);
                        this.evaluateButtonStatus();
                    }
                );
            },
            email(val) {
                this.hideError('email');
                this.formValidator.setValue('email', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('email', error );
                        this.evaluateButtonStatus();
                    }
                );
            },
            address(val) {
                this.hideError('address');
                this.formValidator.setValue('address', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('address', error);
                        this.evaluateButtonStatus();
                    }
                );
            },
            city(val) {
                this.hideError('city');
                this.formValidator.setValue('city', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('city', error);
                        this.evaluateButtonStatus();
                    }
                );
            },
            province(val) {
                this.hideError('province');
                this.formValidator.setValue('province', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('province', error);
                        this.evaluateButtonStatus();
                    }
                );
            },
            zipCode(val) {
                this.hideError('zipCode');
                this.formValidator.setValue('zipCode', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('zipCode', error);
                        this.evaluateButtonStatus();
                    }
                );
            },
            telephone(val) {
                this.hideError('telephone');
                this.formValidator.setValue('telephone', val).then(
                    () => {
                        this.evaluateButtonStatus();
                    },
                    (error) => {
                        this.showError('telephone', error);
                        this.evaluateButtonStatus();
                    }
                );
            }
        },
        methods: {
            hideError(name) {
                this.errors[name] = {};
            },
            showError(name, error) {
                this.errors[name] = {};
                this.errors[name][error] = true;
            },
            evaluateButtonStatus() {
                for( let error in this.errors ){
                    if( Object.keys( this.errors[ error ] ).length > 0 ){
                        this.submitLock = true;
                        return;
                    }
                }
                this.submitLock = false;
            },

            validateInput(field) {

                if(field === 'terms') {
                    if(!this.terms) {
                        this.showErrorTerms = true;
                        this.errorMessageTerms = this.messageValidate;
                    } else {
                        this.showErrorTerms = false;
                        this.errorMessageTerms = '';
                    }
                }

                if(field === 'privacy') {
                    if(!this.privacy) {
                        this.showErrorPrivacy = true;
                        this.errorMessagePrivacy = this.messageValidate;
                    } else {
                        this.showErrorPrivacy = false;
                        this.errorMessagePrivacy = '';
                    }
                }

            },


            handleCreate(e) {
                e.preventDefault();
                this.$emit('wait', true);
                this.validateInput('firstName');

                this.validateInput('terms');
                this.validateInput('privacy');

                if(this.showErrorTerms | this.showErrorPrivacy) return;

                const formData = new FormData();
                formData.append('firstName', this.firstName);
                formData.append('lastName', this.lastName);
                formData.append('email', this.email);
                formData.append('company', this.company);
                formData.append('address', this.address);
                formData.append('address2', this.address2);
                formData.append('city', this.city);
                formData.append('country', this.country);
                formData.append('province', this.province);
                formData.append('zipCode', this.zipCode);
                formData.append('telephone', this.telephone);
                formData.append('terms', this.terms ? 1 : 0);
                formData.append('privacy', this.privacy ? 1 : 0)
                formData.append('_token', this.csrfToken);

                fetch(this.createUrl, {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    if (data.errors) {
                        if(data.errors.email) {
                            document.getElementById("emailError").style.display= "block";
                            document.getElementById("emailError").innerHTML = data.errors.email[0]
                            document.getElementById("email").classList.add("is-invalid")
                        }
                        this.errors = data.errors;
                    } else {
                        document.getElementById("emailError").style.display= "none";
                        this.redirectUrl = data.redirect;
                        this.showAlert = true;
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.$emit('wait', false)
                });
            },

            allowOnlyLetters(e) {
                const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
                if(!regex.test(e.key)) {
                    e.preventDefault();
                }
            },

            allowOnlyEmail(e) {
                const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s@.]+$/;
                if(!regex.test(e.key)) {
                    e.preventDefault();
                }
            },

            validatePhoneNumber(e) {
                const allowedCharsRegex = /^[0-9]*\+?[0-9]*$/;

                if (!allowedCharsRegex.test(e.key)) {
                    e.preventDefault();
                    return;
                }

                if (e.key === '+') {
                    if (e.target.value.includes('+') || e.target.selectionStart !== 0) {
                    e.preventDefault();
                    }
                }
            },

            validateZipCode(e) {
                const key = e.key;

                if (/[0-9]/.test(key)) {
                    return;
                }

                if (key === '-') {
                    const dashCount = (e.target.value.match(/-/g) || []).length;
                    if (dashCount < 2) {
                    return;
                    }
                }

                e.preventDefault();
            },

            removeInvalidClass(e) {
                e.target.classList.remove('is-invalid');
            },

            removeExtraSpaces(field, event) {
                const newValue = event.target.value.replace(/\s{2,}/g, ' ');
                event.target.value = newValue;
                this[field] = newValue;
            }
        },


    }
</script>

